import { useCustomMutation } from '../../graphql';

export interface RequestAssetAccessInput {
  assetId: string;
  workspaceId: string;
  message?: string;
}

export const useRequestAssetAccess = () => {
  const { mutateAsync, isPending } = useCustomMutation({
    query: REQUEST_ASSET_ACCESS,
  });

  const requestAssetAccess = async (input: RequestAssetAccessInput) => {
    return mutateAsync({ input });
  };

  return { requestAssetAccess, isLoading: isPending };
};

const REQUEST_ASSET_ACCESS = `
  mutation Asset($input: RequestAssetAccessInput!) {
    asset {
      requestAssetAccess(input: $input) {
        success
        issueId
        message
      }
    }
  }
`;
